import { render, staticRenderFns } from "./EffectTile.vue?vue&type=template&id=13b21cd4&scoped=true"
import script from "./EffectTile.vue?vue&type=script&lang=js"
export * from "./EffectTile.vue?vue&type=script&lang=js"
import style0 from "./EffectTile.vue?vue&type=style&index=0&id=13b21cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b21cd4",
  null
  
)

export default component.exports